import { render, staticRenderFns } from "./SimulationDetailNavTab.vue?vue&type=template&id=2c30f350"
import script from "./SimulationDetailNavTab.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailNavTab.vue?vue&type=script&lang=ts"
import style0 from "./SimulationDetailNavTab.vue?vue&type=style&index=0&id=2c30f350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports